const EXAMPLE_PROJECTS = [
    {
        id: 'starter-project',
        title: 'Starter Project',
        assetPath: 'static/examples/starter-project.xc'
    },
    {
        id: 'monitor-demo',
        title: 'Monitor Demo',
        assetPath: 'static/examples/monitor-demo.xc'
    }
];

const buildExampleProjectUrl = assetPath => {
    const normalizedPath = assetPath.replace(/^\/+/, '');
    const {origin, pathname} = window.location;
    const lastSegment = pathname.split('/').pop() || '';
    const basePath = pathname.endsWith('/') ?
        pathname :
        (lastSegment.includes('.') ? pathname.replace(/[^/]+$/, '') : `${pathname}/`);
    const encodedPath = normalizedPath
        .split('/')
        .map(segment => encodeURIComponent(segment))
        .join('/');

    return new URL(encodedPath, `${origin}${basePath}`).toString();
};

const resolveExampleProjectUrl = assetPath => buildExampleProjectUrl(
    assetPath.replace(/^\/+/, '')
);

export {
    EXAMPLE_PROJECTS,
    resolveExampleProjectUrl
};
